/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import { AnalyticsResultFormatterMessage } from '../../../messages/analytics-result-formatter.message';

const formatNumber = (number: number) => {
  return new Intl.NumberFormat('en-GB', {
    notation: 'compact',
    compactDisplay: 'short',
    minimumFractionDigits: 0,
  }).format(number);
};

export const triggerRegionStatsPeriodicity = (lifeCycle: any) => {
  const message = lifeCycle?.fsm?.message as AnalyticsResultFormatterMessage;
  const template = message?.template?.layout[0]?.colProps;
  for (const obj of message?.raw?.regionStats) {
    const found = template?.find(
      (o: any) => o.key === `${obj.country?.trim()?.toLowerCase()}-policyValue`
    );
    if (found) {
      if (found?.compProps) {
        found.compProps.value = formatNumber(
          (obj?.totalActualPolicies?.raw ?? 0) +
            (obj?.totalProvisionalPolicies?.raw ?? 0)
        );
      }
      if (obj?.day?.labels) {
        found.compProps.salesValue.day.labels = obj?.day?.labels;
      }
      if (obj?.week?.labels) {
        found.compProps.salesValue.week.labels = obj?.week?.labels;
      }
      if (obj?.month?.labels) {
        found.compProps.salesValue.month.labels = obj?.month?.labels;
      }
      if (obj?.year?.labels) {
        found.compProps.salesValue.year.labels = obj?.year?.labels;
      }
      if (obj?.day?.chartSeries) {
        for (const templObj of found?.compProps?.salesValue?.day?.chartSeries) {
          const _found = obj?.day?.chartSeries?.find(
            (o: any) =>
              o.name?.trim()?.toLowerCase() ===
              templObj?.name?.trim()?.toLowerCase()
          );
          if (_found?.data) {
            templObj.data = _found?.data?.map((d: number) => Math.round(d));
          }
        }
      }
      if (obj?.week?.chartSeries) {
        for (const templObj of found.compProps.salesValue.week?.chartSeries) {
          const _found = obj?.week?.chartSeries?.find(
            (o: any) =>
              o.name?.trim()?.toLowerCase() ===
              templObj?.name?.trim()?.toLowerCase()
          );
          if (_found?.data) {
            templObj.data = _found?.data?.map((d: number) => Math.round(d));
          }
        }
      }
      if (obj?.month?.chartSeries) {
        for (const templObj of found.compProps.salesValue.month?.chartSeries) {
          const _found = obj?.month?.chartSeries?.find(
            (o: any) =>
              o.name?.trim()?.toLowerCase() ===
              templObj?.name?.trim()?.toLowerCase()
          );
          if (_found?.data) {
            templObj.data = _found?.data?.map((d: number) => Math.round(d));
          }
        }
      }
      if (obj?.year?.chartSeries) {
        for (const templObj of found.compProps.salesValue.year?.chartSeries) {
          const _found = obj?.year?.chartSeries?.find(
            (o: any) =>
              o.name?.trim()?.toLowerCase() ===
              templObj?.name?.trim()?.toLowerCase()
          );
          if (_found?.data) {
            templObj.data = _found?.data?.map((d: number) => Math.round(d));
          }
        }
      }
      console.log('region stats found templ ->', found.compProps.salesValue);
    }
  }
  return true;
};
